const FAVORITES_ID = 'favorites';

export { FAVORITES_ID };
